import script from "./RogainingView.vue?vue&type=script&setup=true&lang=js"
export * from "./RogainingView.vue?vue&type=script&setup=true&lang=js"

import "./RogainingView.vue?vue&type=style&index=0&id=7b9ccf30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9ccf30"]])

export default __exports__